import React, { useState } from "react";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import PageStyle from "../../../Components/Layout/PageLayout";
import { useNavigate, useParams } from "react-router";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import {
  useDeleteSurveyMutation,
  useGetFinanceSurveyByIdQuery,
} from "../../../../api/financeApi";
import { filterSurveyStatus } from ".";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import DeleteItemModal from "../../../Components/Modals/DeleteItemModal";
import toast from "react-hot-toast";
import { CustomPopover } from "../../../Components/Popover/Popover";

const ViewSurvey = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [openDelete, setOpenDelete] = useState(false);
  const handleCloseDelete = () => setOpenDelete(false);
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const [onDelete, { isLoading: deleteLoading }] = useDeleteSurveyMutation();
  const handleDelete = async () => {
    try {
      const response = await onDelete({ id }).unwrap();
      if (response?.successful) {
        setOpenDelete(false);
        toast.success(response?.statusMessage);
        navigate(-1)
      }
    } catch (e) {
      toast.error(e?.data?.statusMessage);
    }
  };
  const { data } = useGetFinanceSurveyByIdQuery(id);
  const popoverItems = [
    {
      value: "Edit",
      label: "Edit",
      click: () => navigate(`/dashboard/finance/feedback-survey/${id}/edit`),
    },
    {
      value: "Delete",
      label: "Delete",
      click: () => handleOpenDelete(),
    },
  ];
  const actionButton = (
    <div>
      <CustomPopover
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        options={popoverItems}
        children={
          <CTAButtons onClick={() => setIsOpen(!isOpen)}>Action</CTAButtons>
        }
      />
    </div>
  );
  const itemType = (type) => {
    switch (type) {
      case 4:
        return "text";
      case 5:
        return "textarea";
      case 2:
        return "radio";
      case 1:
        return "checkbox";
      case 3:
        return "rating";
      default:
        return "";
    }
  };
  return (
    <RouteLayout navHidden={true}>
      <PageStyle
        hasBack={true}
        demoTitle={"Feedback Survey Details"}
        hasTopPageDemo
        action={actionButton}
      >
        <div className={DashboardStyle.view_app_components}>
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Process Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Process Type:</p>
                  <h4>Field Survey</h4>
                </div>
                <div>
                  <p>Date Requested:</p>
                  <h4>{FormatDateTime(data?.result?.createdDate)}</h4>
                </div>
                <div>
                  <p>Approval Status:</p>
                  <h4>
                    {filterSurveyStatus.filter(
                      (item) => item.id === data?.result?.approvalStatus,
                    )?.name || "N/A"}
                  </h4>
                </div>
              </div>
              <div>
                <div>
                  <p>Requested By:</p>
                  {/* <h4>{data?.responseObject?.requestorName}</h4> */}
                </div>
                {/* <div>
                                      <p>Employee Group:</p>
                                      <h4>{request?.employeeGroup?.title}</h4>
                                    </div> */}
              </div>
            </div>
          </section>
          {data?.result?.questions?.map((item, index) => (
            <section
              key={index + 1}
              style={{
                backgroundColor: "#F8FBF8",
                border: "1px solid #D9E9DA",
                borderRadius: "8px",
              }}
              className={DashboardStyle.form_section}
            >
              <h4 className={DashboardStyle.form_section_title}>
                Question {index + 1}
              </h4>
              <div className={DashboardStyle.labels_group}>
                <div>
                  <div>
                    <p>Question Type:</p>
                    <h4>{itemType(item?.questionType)}</h4>
                  </div>
                  <div>
                    <p>Maximum Character:</p>
                    <h4>{item?.displayOrder}</h4>
                  </div>
                  <div>
                    <p>Compulsory:</p>
                    <h4>{item.isRequired ? "Yes" : "No"}</h4>
                  </div>
                </div>
                <div>
                  <div>
                    <p>Question:</p>
                    <h4>{item?.questionText}</h4>
                  </div>
                </div>
                {item?.questionType === 3 &&
                  item.options?.length > 0 &&
                  item?.options.map((opt, idx) => (
                    <div key={idx}>
                      <div>
                        <p>Options:</p>
                        <h4>{opt?.optionText}</h4>
                      </div>
                    </div>
                  ))}
              </div>
            </section>
          ))}
        </div>
      </PageStyle>
      <DeleteItemModal
        isOpen={openDelete}
        handleClose={handleCloseDelete}
        handleDelete={handleDelete}
        headText={"Delete Survey"}
        infoText={"Are you sure you want to Delete this Survey?"}
        isLoading={deleteLoading}
      />
    </RouteLayout>
  );
};

export { ViewSurvey };
